function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#45464D",
  points: "684.785,62.012 279.391,43.92 43.353,338.768 208.746,732.812 618.195,757.601  851.266,426.113  "
});

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#656569",
  points: "851.266,426.527 620.33,192.34 559.592,641.584  "
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "url(#SVGID_1_)",
  points: "200.71,373.854 620.33,192.34 559.592,641.584  "
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "url(#SVGID_2_)",
  points: "620.33,192.34 279.391,44.335 200.71,373.854  "
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "url(#SVGID_3_)",
  points: "200.71,373.854 208.746,733.228 559.592,641.584  "
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#757578",
  points: "620.33,192.34 684.785,62.427 279.391,44.335  "
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#6C6D70",
  points: "684.785,62.427 851.266,426.527 620.33,192.34  "
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#6C6D70",
  points: "851.266,426.527 618.195,758.015 559.592,641.584  "
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#55565A",
  points: "618.195,758.015 208.746,733.228 559.592,641.584  "
});

var _ref11 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#55565A",
  points: "279.391,44.335 43.353,339.182 200.71,373.854  "
});

var _ref12 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "#656569",
  points: "43.353,339.182 208.746,733.228 200.71,373.854  "
});

var _ref13 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#151A22",
  points: "577.386,254.212 534.854,576.277 284.176,382.374  "
});

var _ref14 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#151A22",
  points: "543.44,189.992 309.117,89.053 259.895,301.28  "
});

var _ref15 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#23262E",
  points: "484.048,625.068 229.384,443.142 235.543,689.66  "
});

var _ref16 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#23262E",
  points: "808.476,425.723 634.935,249.55 589.129,588.326  "
});

var _ref17 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#43444B",
  points: "543.756,664.691 581.555,737.034 328.979,720.854  "
});

var _ref18 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#34363D",
  points: "774.56,505.654 586.556,645.771 623.913,718.809  "
});

var _ref19 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#34363D",
  points: "685.632,113.299 785.035,326.52 649.118,188.295  "
});

var _ref20 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#36383F",
  points: "640.137,77.41 598.339,153.872 401.46,67.719  "
});

var _ref21 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#3B3C43",
  points: "245.925,112.093 190.52,346.971 78.747,323.285  "
});

var _ref22 =
/*#__PURE__*/
React.createElement("polygon", {
  opacity: 0.7,
  fill: "#45464D",
  points: "183.779,388.397 188.656,640.808 71.468,364.609  "
});

var SvgKlerosSymbol = function SvgKlerosSymbol(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "896.076px",
    height: "810px",
    viewBox: "0 0 896.076 810",
    enableBackground: "new 0 0 896.076 810",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", null, _ref2, React.createElement("g", null, _ref3, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.71,
    y1: 416.9619,
    x2: 620.3301,
    y2: 416.9619
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A3A2A5"
    }
  }), React.createElement("stop", {
    offset: 0.2705,
    style: {
      stopColor: "#9F9EA0"
    }
  }), React.createElement("stop", {
    offset: 0.5607,
    style: {
      stopColor: "#929194"
    }
  }), React.createElement("stop", {
    offset: 0.8592,
    style: {
      stopColor: "#7C7C80"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707073"
    }
  })), _ref4, React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.9355,
    y1: 367.832,
    x2: 496.0872,
    y2: 72.5576
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#969598"
    }
  }), React.createElement("stop", {
    offset: 0.3396,
    style: {
      stopColor: "#908F92"
    }
  }), React.createElement("stop", {
    offset: 0.7917,
    style: {
      stopColor: "#7F7F82"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#757578"
    }
  })), _ref5, React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.916,
    y1: 363.666,
    x2: 380.1855,
    y2: 679.5057
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E9EA0"
    }
  }), React.createElement("stop", {
    offset: 0.2759,
    style: {
      stopColor: "#9B9B9D"
    }
  }), React.createElement("stop", {
    offset: 0.494,
    style: {
      stopColor: "#919194"
    }
  }), React.createElement("stop", {
    offset: 0.6923,
    style: {
      stopColor: "#808083"
    }
  }), React.createElement("stop", {
    offset: 0.8777,
    style: {
      stopColor: "#69696D"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55565A"
    }
  })), _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKlerosSymbol, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kleros-symbol.c594a5f5.svg";
export { ForwardRef as ReactComponent };